export function hasArrayErrors(props, key) {
  return Array.isArray(props?.[key]) && props[key].length > 0;
}

export function hasMatchingId(props, key, id) {
  const value = props?.[key];

  if (value == null) return false;
  if (typeof value === "string" || typeof value === "number") return value === id;
  if (typeof value === "object") return value.id === id;

  return false;
}

export function handleDrawerSuccess(page, shouldStayOpen, onSuccess) {
  const props = page?.props || {};

  if (shouldStayOpen(props)) return;

  onSuccess?.(page);
}
